























































import VueOptions from '@utils/VueOptions'
import Modal from '@components/Modal'
import RequestButton from '@/components/RequestButton'

settings =
  name: 'BulkEditCartModal'

  resources:
    cart:
      resourceName: 'shopping_cart'
      slug: 'campaigns/:campaignId/shopping_cart'
      fetch: false

  vue:
    props: ['show']

    components: {
      Modal,
      RequestButton,
    }

    data: ->
      activeTab: 0

      addForm:
        listing_id_text: null

      editForm:
        spreadsheet_url: null

    computed:
      disableAddForm: -> @requestIsPending
      canSubmitAddForm: -> @addForm.listing_id_text?.trim().length > 0

      disableEditForm: -> @requestIsPending
      canSubmitEditForm: -> @editForm.spreadsheet_url?.trim().length > 0

    methods:
      hiClose: ->
        @$emit 'update:show', false

      clearForms: ->
        @addForm.listing_id_text = null
        @editForm.spreadsheet_url = null

      hiSubmitAddForm: ->
        @triggerResource 'cart', 'bulk_add_to_cart', @addForm
      onCartBulkAddToCart: ->
        @clearForms()
        @fetchProgressBars()
        @hiClose()

      hiSubmitEditForm: ->
        @triggerResource 'cart', 'bulk_edit_cart', @editForm
      onCartBulkEditCart: ->
        @clearForms()
        @fetchProgressBars()
        @hiClose()

      hiDownloadTemplate: ->
        @triggerResource 'cart', 'generate_bulk_edit_cart_template'
      onCartExportBulkCart: ->

export default VueOptions.vue settings
